export default "__VITE_ASSET__XAK1EosX__"